// components/products/ImageUpload.jsx
import React from "react";
import { ImagePlus } from "lucide-react";

const ImageUpload = ({ image, onImageChange }) => {
  return (
    <div
      className="border-2 border-dashed border-orange-200 rounded-lg p-6 cursor-pointer hover:border-orange-300"
      onClick={() => document.getElementById("imageInput").click()}
    >
      {image ? (
        <div className="text-center">
          <p className="text-sm text-gray-600">
            {typeof image === "string" ? image : image.name}
          </p>
        </div>
      ) : (
        <div className="text-center">
          <ImagePlus className="mx-auto h-12 w-12 text-gray-400" />
          <p className="mt-2 text-sm text-gray-600">Upload</p>
        </div>
      )}
      <input
        id="imageInput"
        type="file"
        className="hidden"
        onChange={onImageChange}
        accept="image/*"
      />
    </div>
  );
};

export default ImageUpload;
